module.exports = __webpack_public_path__ + "img/9788959407514.acbaa498.jpg";